/**
 * Flyout (Button and Garage) Container
 * Needs to be as fast as possible and avoid rerenders.
 * Don't use deeply nested objects from store if possible.
 */
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { ApplicationStore } from "src/store";
import { toggleFlyout } from "src/store/actions/onlineShopper/flyout";
import Flyout from "./FlyoutComponent";

const getGarageType = (len: number): "empty" | "simple" | "multi" => {
    if (len === 1) return "simple";
    if (len >= 2) return "multi";
    return "empty";
};

const mapStateToProps = ({ account, onlineShopper, vehicles }: ApplicationStore) => ({
    env: onlineShopper.env,
    garageType: getGarageType(vehicles.order.length),
    isAccountLoading: account.loading,
    isAppOpen: onlineShopper.isAppOpen,
    isOpen: onlineShopper.isFlyoutOpen,
    settings: account.settings?.electric,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    toggleBodyHide: () => dispatch(toggleFlyout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Flyout);
